import cn from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

export interface ICardSectionNewProps {
  id?: string;
  withBorders?: boolean;
  withBorder?: boolean;
  children: React.ReactNode;
}

export const CardSectionNew: React.FC<ICardSectionNewProps> = ({ id, withBorder, withBorders, children }) => {
  return (
    <div className={styles['section']} id={id}>
      <div className={cn(styles['item'], withBorder && styles['with-border'])}>
        <div className={cn(styles['inner'], withBorders && styles['with-borders'])}>{children}</div>
      </div>
    </div>
  );
};
